// @flow
import $ from 'jquery';

import JQueryView, { on } from '../../common/JQueryView';
import maskInput from '../../../utils/maskInput';
import StockAcquisitionRightClient from '../../../clients/StockAcquisitionRightClient';
import rightsFormValidator from './rightsFormValidator';

export default class StockAcquisitionRightsFormView extends JQueryView {
  origForm: string;

  client = new StockAcquisitionRightClient();

  constructor() {
    super('.rights-form');
    this.render();
  }

  @on({ event: 'click', selector: '.btn-submit-right' })
  handleSubmitForm(e: any) {
    e.preventDefault();
    if (this.$el.serialize() === this.origForm) {
      $('#stockModal').modal('hide');
      return;
    }
    const url = `${e.currentTarget.closest('form').action}`;
    const method =
      $(e.currentTarget.closest('form'))
        .find('input[name="_method"]')
        .val() || $(e.currentTarget.closest('form')).prop('method');
    const data = this.$el.serialize();
    if (this.$el.valid()) {
      this.client.updateStockAcquisitionRight(url, method, data);
    }
  }

  render() {
    this.origForm = this.$el.serialize();
    rightsFormValidator();
    maskInput();
  }
}
